import stockRequest from '@js/store/modules/stock-request';
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('stockRequest', [
            'status',
            'stockRequest',
            'hasFinalized',
            'request_from_outlet',
            'request_to_outlet',
        ]),

        isOpen() {
            return this.status == this.statuses.OPENED;
        },

        isWaitingApproval() {
            return this.status == this.statuses.REQUESTED;
        },

        isApproved() {
            return this.status == this.statuses.APPROVED;
        },

        isDeclined() {
            return this.status == this.statuses.DECLINED;
        },

        canUpdate() {
            return (
                this.can(this.permission.SAVE_STOCK_REQUEST) &&
                this.canAccessOutlet(this.stockRequest.request_to_outlet_id) &&
                (this.isApproved || this.isOpen)
            );
        },

        canApprove() {
            return (
                this.can(this.permission.SAVE_STOCK_REQUEST) &&
                this.canAccessOutlet(
                    this.stockRequest.request_from_outlet_id,
                ) &&
                this.isWaitingApproval
            );
        },

        statuses() {
            return {
                OPENED: 0,
                DECLINED: 1,
                REQUESTED: 2,
                APPROVED: 3,
                RECEIVED: 4,
            };
        },

        isLoading() {
            return (
                this.onLoading('save-stock-request') ||
                this.onLoading('send-stock-request') ||
                this.onLoading('approve-stock-request') ||
                this.onLoading('receive-stock-request') ||
                this.onLoading('fetch-stock-request')
            );
        },
    },

    beforeCreate() {
        if (!this.$store.hasModule('stockRequest')) {
            this.$store.registerModule('stockRequest', stockRequest);
        }
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/stock_request/stock-request-mixin.js